export default {
  drawer: null,
  // drawerBg: '/img/dxc.jpg',
  color: 'success',
  logo: '/img/galaxylogo.png',
  accountInventoryBg: '/img/galaxy_bg.png',
  selectedFilter: null,
  networkError: false,
  adminmenus: [
    {
      to: '/admin/account-inventory',
      icon: 'mdi-account',
      group: 'account-inventory',
      text: 'Account Inventory',
      expand: [false],
      items: [
        {
          value: 'byAWSAgreement',
          label: 'By AWS Agreement',
          active: false,
          route: '/admin/account-inventory/aws-agreement'
        },
        {
          value: 'byMasterPayer',
          label: 'By Master Payer',
          active: false,
          route: '/admin/account-inventory/master-payer'
        },
        {
          value: 'byCustomer',
          label: 'By Customer',
          active: false,
          route: '/admin/account-inventory/customers'
        },
        // {
        //   value: 'byLinkedAccount',
        //   label: 'By Linked Account',
        //   active: false,
        //   route: '/admin/account-inventory/linked-account'
        // }
      ]
    },
    {
      to: '/admin/oppreg-administration',
      icon: 'mdi-view-dashboard',
      group: 'oppreg-administration',
      expand: [false],
      text: 'OppReg Administration',
      items: [
        {
          value: 'updateAdminContent',
          label: 'Update Admin Content',
          active: false,
          route: '/admin/oppreg-administration/admin-content',
          color: '#41B3DF'
        },
        {
          value: 'GeneralReporting',
          label: 'General Reporting',
          active: false,
          route: '/admin/oppreg-administration/general-reporting'
        },
        {
          value: 'ViewAllRegistrations',
          label: 'View All Registrations',
          active: false,
          route: '/admin/oppreg-administration/view-all-registrations'
        },
        {
          value: 'DraftRegistrations',
          label: 'Draft Registrations',
          active: false,
          route: '/admin/oppreg-administration/draft-opportunities'
        }
      ]
    },
    {
      to: '/admin/onboard-aws-account',
      icon: 'mdi-clipboard-outline',
      group: 'onboarding',
      expand: [false],
      text: 'Onboard AWS Account',
      items: [
        {
          value: 'viewRequest',
          label: 'View Requests',
          active: false,
          route: '/admin/onboard-aws-account/view-request'
        },
        // {
        //   value: 'processNew',
        //   label: 'Process New Account Request',
        //   active: false,
        //   route: '/admin/onboard-aws-account/process-new'
        // },
        {
          value: 'updateWorkflow',
          label: 'Update Onboarding Account Workflow',
          active: false,
          route: '/admin/onboard-aws-account/update-workflow'
        }
      ]
    },
    {
      to: '/admin/onboard-masterpayer',
      icon: 'mdi-clipboard-outline',
      group: 'onboarding-masterpayer',
      expand: [false],
      text: 'Onboard AWS Masterpayer',
      items: [
        {
          value: 'viewRequest',
          label: 'View Requests',
          active: false,
          route: '/admin/onboard-masterpayer/view-request'
        }
      ]
    },
    {
      to: '/admin/attestations',
      icon: 'mdi-clipboard-outline',
      group: 'attestations',
      expand: [false],
      text: 'Submitted Attestations',
      items: [
        {
          value: 'viewAttestations',
          label: 'View Attestations',
          active: false,
          route: '/admin/attestations/view-requests'
        }
      ]
    },
    {
      to: '/admin/request-managed-services',
      icon: 'mdi-account-box-multiple',
      group: 'request-managed-services',
      expand: [false],
      text: 'Customer Owned Accounts - Request Managed Svcs',
      class: 'customer-owned-accounts',
      items: [
        {
          value: 'viewRequest',
          label: 'View All Requests',
          active: false,
          route: '/admin/request-managed-services/view-request'
        }
      ]
    },
    // {
    //   to: '/admin/financial-administration',
    //   icon: 'mdi-format-font',
    //   group: 'financial',
    //   expand: [false],
    //   text: 'Financial Administration',

    //   items: [
    //     {
    //       value: 'financialmodule',
    //       label: 'Monthly Cross Charge',
    //       active: false,
    //       route: '/admin/financial-administration/monthly-cross-charge/aws-agreement',
    //       color: '#41B3DF'
    //     },
    //     {
    //       value: 'financialmodule',
    //       label: 'Dashboard',
    //       active: false,
    //       route: '/admin/financial-administration/dashboard',
    //       color: '#41B3DF'
    //     },
    //     {
    //       value: 'financialmodule',
    //       label: 'Burndown Reporting',
    //       active: false,
    //       route: '/admin/financial-administration/burndown-reporting',
    //       color: '#41B3DF'
    //     },
    //     {
    //       value: 'financialmodule',
    //       label: 'Admin Section - Update Records',
    //       active: false,
    //       route: '/admin/financial-administration/admin-section-update-records',
    //       color: '#41B3DF'
    //     }
    //   ]

    // }
  ],
  usermenus: [
    {
      to: '/request-oppreg',
      icon: 'mdi-account-plus',
      group: 'request-oppreg',
      text: 'Opportunity Registrations',
      expand: [false],
      items: [
        {
          value: 1,
          label: 'Register New Opportunity',
          active: false,
          route: '/request-oppreg/external-oppreg'
        },
        // {
        //   value: 2,
        //   label: 'Register New Workload Request to Existing Registered Opportunity',
        //   active: false,
        //   route: '/request-oppreg/new-workload-to-existing-opportunity'
        // },
        // AGAM-557 - Hide unused modules
        // Not in use at the moment
        // {
        //   value: 3,
        //   label: 'Register New Workload or Existing Client(not opportunity based)',
        //   active: false,
        //   route: '/request-oppreg/new-workload-or-existing-client'
        // },
        {
          value: 4,
          label: 'View All Requests',
          active: false,
          route: '/request-oppreg/view-all-requests'
        },
        {
          value: 5,
          label: 'Update Discount Qualification',
          active: false,
          route: '/request-oppreg/update-discount'
        }
      ]
    },
    // AGAM-557 - Hide unused modules
    {
      to: '/request-aws-account',
      icon: 'mdi-account-star',
      group: 'request-aws-account',
      text: 'Request New AWS Accounts',
      expand: [false],
      items: [
        // {
        //   value: 1,
        //   label: 'Request New AWS Account Onboarding Portal',
        //   active: false,
        //   route: '/request-oppreg/request-aws-account'
        // },
        {
          value: 2,
          label: 'Request New Account for New Clients',
          active: false,
          route: '/request-aws-account/new-account-for-registered-opportunity'
        },
        {
          value: 3,
          label: 'Request New Account for Existing Client',
          active: false,
          route: '/request-aws-account/request-new-account-for-existing-client'
        },
        {
          value: 4,
          label: 'Request New Account For DXC Internal Usage',
          active: false,
          route: '/request-aws-account/request-new-account-for-internal-client'
        },
        {
          value: 5,
          label: 'Request New Training Account',
          active: false,
          route: '/request-aws-account/request-new-training-account'
        }
      ]
    },
    // AGAM-557 - Hide unused modules
    // {
    //   to: '/link-existing-aws-account',
    //   icon: 'mdi-account-network',
    //   group: 'link-existing-aws-account',
    //   text: 'Link Existing Aws Account',
    //   expand: [false],
    //   items: []
    // },
    // AGAM-557 - Hide unused modules
    {
      to: '/list-aws-account',
      icon: 'mdi-account-search',
      group: 'list-aws-account',
      text: 'List my AWS Accounts',
      expand: [false],
      items: [
        {
          value: 1,
          label: 'View My Requests',
          active: false,
          route: '/list-aws-account/view-my-requests'
        }
      ]
    },
    // AGAM-557 - Hide unused modules
    // Not in use at the moment
    // {
    //   to: '/link-existing-aws-account',
    //   icon: 'mdi-account-network',
    //   group: 'link-existing-aws-account',
    //   text: 'Link Existing Aws Account',
    //   expand: [false],
    //   items: []
    // },
    // {
    //   to: '/list-aws-account',
    //   icon: 'mdi-account-search',
    //   group: 'list-aws-account',
    //   text: 'List my AWS Accounts',
    //   expand: [false],
    //   items: []
    // },
    // AGAM-557 - Hide unused modules
    {
      to: '/how-to-guides',
      icon: 'mdi-book-open-page-variant',
      group: 'how-to-guides',
      text: 'View and Download Guides',
      expand: [false],
      items: [
        {
          value: 2,
          label: 'Download Oppreg Guide',
          active: false,
          route: '/how-to-guides/download-oppreg-guide'
        },
        {
          value: 3,
          label: 'Download Account Onboarding Guide',
          active: false,
          route: '/how-to-guides/download-account-onboarding-guide'
        },
        {
          value: 4,
          label: 'Download Internal/External Definition',
          active: false,
          route: '/how-to-guides/download-definition-aws-account'
        },
        {
          value: 5,
          label: 'Download IWO WBS Creation Process',
          active: false,
          route: '/how-to-guides/download-iwo-wbs-creation-process'
        }
      ]
    },
    {
      to: '/masterpayer-request',
      icon: 'mdi-account-plus',
      group: 'masterpayer-request',
      text: 'Masterpayer Request',
      expand: [false],
      items: [
        {
          value: 1,
          label: 'Request New Masterpayer',
          active: false,
          route: '/masterpayer-request/new'
        },
        {
          value: 2,
          label: 'View All Request',
          active: false,
          route: '/masterpayer-request/view'
        },
      ]
    },
    {
      to: '/attestation',
      icon: 'mdi-account-plus',
      group: 'attestation-request',
      text: 'Attestation Request',
      expand: [false],
      items: [
        {
          value: 1,
          label: 'Single Attestation',
          active: false,
          route: '/attestation/single'
        },
        {
          value: 2,
          label: 'Bulk Attestation',
          active: false,
          route: '/attestation/bulk'
        }
      ]
    },
    {
      to: '/request-managed-services',
      icon: 'mdi-account-box-multiple',
      group: 'request-managed-services',
      expand: [false],
      text: 'Customer Owned Accounts - Request Managed Svcs',
      class: 'customer-owned-accounts',
      items: [
        {
          value: 'viewRequest',
          label: 'Create New Request',
          active: false,
          route: '/request-managed-services/new'
        },
        {
          value: 'viewRequest',
          label: 'View All Requests',
          active: false,
          route: '/request-managed-services/list'
        }
      ]
    },

  ],
  admintools: [
    {
      to: '/admin/customers',
      icon: 'mdi-account-box-multiple',
      text: 'Customers'
    },
    {
      to: '/admin/master-payer',
      icon: 'domain',
      text: 'View All Master Payer Account List'
    },
    {
      to: '/admin/email-audit-trail',
      icon: 'email',
      text: 'View Email Audit Trail'
    }
  ]
}
